import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiGet, apiPost } from "../../utils/api";

const ArticlesAdmin = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    async function exibir() {
      const payload = apiGet("/article");
      setArticles((await payload).data.data);
    }

    exibir();
  }, []);

  function deleteArticle(id) {
    deleteById(id).then(
      (payload) => {
        // setState(articleEmpty);
        alert("Artigo removido!", "success");

        setArticles(articles.filter((item) => item.article_id !== id));
      },
      (error) => {
        let message = "Erro ao remover!";

        if (error.status === 401) {
          message = "Sem autorização.";
          // toLogin();
        }
        alert(message, "error");
      }
    );
  }

  async function deleteById(articleId) {
    const payload = apiPost("/article/delete/" + articleId);
    return await payload;
  }

  return (
    <div>
      <section id="management" style={{ paddingTop: "100px" }}>
        <div className="row text-center justify-content-center">
          <h2 className="text-black mb-4">Gerenciar os artigos</h2>
        </div>
      </section>

      <div className="row m-1">
        <div>
          <Link to="/management/articles/create" className="btn btn-primary">
            Cadastrar novo artigo
          </Link>
          &nbsp;&nbsp;&nbsp;
          <Link className="btn btn-secondary" to={"/management"}>
            Voltar
          </Link>
        </div>
      </div>

      {articles && articles.length
        ? articles.map((article) => {
            // console.log(article)
            return (
              <div className="row m-1 posts" key={article.article_id}>
                <div className="card mb-3">
                  <div className="col-lg-12">
                    <article>
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <b>Título:</b>
                            </td>
                            <td>{article.title}</td>
                          </tr>
                          <tr>
                            <td>
                              <b>Autores:</b>
                            </td>
                            <td>{article.authors} </td>
                          </tr>
                          <tr>
                            <td>
                              <b>Veículo:</b>
                            </td>
                            <td>{article.dissemination_vehicle}</td>
                          </tr>
                          <tr>
                            <td>
                              <b>Ano:</b>
                            </td>
                            <td>{article.year}</td>
                          </tr>
                          <tr>
                            <td>
                              <b>Categoria:</b>
                            </td>
                            <td>{article.category}</td>
                          </tr>
                          <tr>
                            <td>
                              <b>Link:</b>
                            </td>
                            <td>
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={article.access_link}
                              >
                                Acessar o link da publicação.
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </article>
                    <p>
                      <Link
                        to={`/management/articles/edit/${article.article_id}`}
                        className="btn btn-success"
                      >
                        Editar Artigo
                      </Link>
                      &nbsp;&nbsp;&nbsp;
                      <button
                        onClick={() => deleteArticle(article.article_id)}
                        className="btn btn-primary"
                      >
                        Remover Artigo
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            );
          })
        : null}
    </div>
  );
};

export default ArticlesAdmin;
